import React, { useState, Fragment } from 'react';
import styles from './styles.module.scss';

import { Button, Toaster } from '@densityco/ui';
import { SenseiApi } from '../../../../utils/api';
import { Sensor } from '../../../../types/api';
import { useRequiredSessionToken } from '../../../../utils/session-token';
import { AddNotePopup } from '../../../AddUpdateNoteForm';

type SensorRecalibrateButtonProps = {
  sensors: Array<{serial_number: Sensor['serial_number']}>;
  onComplete?: () => void;
};

const SensorRecalibrateButton: React.FunctionComponent<SensorRecalibrateButtonProps> = props => {
  const { sensors } = props;
  const accessToken = useRequiredSessionToken();

  const [movedNotePopupOpen, setMovedNotePopupOpen] = useState(false);
  const [editorValue, setEditorValue] = useState('');

  return (
    <AddNotePopup
      title="Recalibrate Sensor"
      preFormContent={
        <Fragment>
          <p>When recalibrating a sensor:</p>
          <ul className={styles.list}>
            <li>All of the sensor's captures will be <strong>deleted</strong></li>
            <li>The sensor's <strong>accuracy score will reset</strong></li>
            <li>The sensor state machine will restart (the system will update the OS, automatically collect more captures, etc)</li>
          </ul>
        </Fragment>
      }
      placeholder="Enter a comment specifying why this sensor needs to be recalibrated"
      buttonLabel="Recalibrate"
      submitDisabled={false}
      onSubmit={() => {
        SenseiApi.recalibrate(
          accessToken,
          sensors.map(i => i.serial_number),
          editorValue,
        ).then(() => {
          setMovedNotePopupOpen(false);
          setEditorValue('');
          Toaster.showToast({
            text: `Began recalibration on ${sensors.length} ${sensors.length === 1 ? 'sensor' : 'sensors'}.`,
          });

          if (props.onComplete) {
            props.onComplete();
          }
        }).catch(() => {
          Toaster.showToast({ type: 'error', text: 'Error recalibrating!' });
        });
      }}
      submitLabel={sensors.length === 1 ? 'Recalibrate Sensor' : `Recalibrate ${sensors.length} Sensors`}
      value={editorValue}
      onChangeValue={setEditorValue}
      open={movedNotePopupOpen}
      onOpen={() => setMovedNotePopupOpen(true)}
      onClose={() => setMovedNotePopupOpen(false)}
      position={{ left: -64, top: 44 }}
    />
  );
};

export default SensorRecalibrateButton;
